<template>
  <div id="chamada-publica-log-table">
    <table
      id="chamada-publica-log"
      class="table table-striped table-hover table-sm"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>Acessos</th>
        </tr>
      </thead>
      <tbody
        v-for="modalChamadaPublicaLog in modalChamadasPublicasLogs"
        v-bind:key="modalChamadaPublicaLog.modalChamadaPublicaId"
      >
        <tr>
          <td>{{ modalChamadaPublicaLog.acessos }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { modalChamadaPublicaLogAPI } from "@/modules/log";
import { mapActions } from "vuex";

export default {
  props: {
    filtro: { type: Object, required: true }
  },
  data() {
    return {
      modalChamadasPublicasLogs: []
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getAcessos() {
      this.setLoading(true);
      modalChamadaPublicaLogAPI
        .acessos(this.filtro)
        .then(resp => {
          this.setLoading(false);
          this.modalChamadasPublicasLogs = resp.data;
        })
        .catch(resp => {
          this.setLoading(false);
          this.$toast.error("Erro buscar logs de Chamadas Públicas");
        });
    }
  },
  mounted() {
    this.getAcessos();
  }
};
</script>
